import styled from 'styled-components';

export const PauseContainer = styled.div`
  text-align: left;
  padding: 1rem 1rem 0 1rem;
`;
